var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureAppEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3842_73790)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9404 15.9982C12.8682 15.6583 14.459 15.3771 14.4766 15.3712L14.5088 15.3654L12.6895 13.2003C11.6875 12.0109 10.8701 11.0324 10.8701 11.0265C10.8701 11.0148 12.7481 5.84097 12.7598 5.8234C12.7627 5.81754 14.043 8.02359 15.8594 11.173C17.5615 14.1203 18.9619 16.5519 18.9766 16.5753L19 16.6163H13.2168H7.43359L10.9404 15.9982ZM4 15.339C4 15.3361 4.8584 13.8478 5.9043 12.0314L7.80859 8.72965L10.0293 6.86636C11.251 5.84097 12.2529 5.00308 12.2559 5.00015C12.2588 4.99722 12.2441 5.03824 12.2207 5.09097C12.1973 5.14078 11.1133 7.46988 9.80957 10.2619L7.44238 15.339L5.71973 15.3419C4.77344 15.3419 4 15.3419 4 15.339Z",
    fill: "#0089D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3842_73790",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3842_73790"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureAppEdge);
export default __webpack_public_path__ + "static/media/Azure-App-Edge.fe461f2659b9b995e4d7238afe30e171.svg";
export { ForwardRef as ReactComponent };